import { BaseForm } from './lib/baseForm/baseForm';
import type { FormProps } from './lib/form/form';
import { Form as HookForm } from './lib/form/form';
import type { FormCheckboxFieldProps } from './lib/formCheckboxField/formCheckboxField';
import { FormCheckboxField } from './lib/formCheckboxField/formCheckboxField';
import { FormDateTimeField } from './lib/formDateTimeField/formDateTimeField';
import { FormErrorBanner } from './lib/formErrorBanner/formErrorBanner';
import type { FormNumberFieldProps } from './lib/formNumberField/formNumberField';
import { FormNumberField } from './lib/formNumberField/formNumberField';
import { FormRadioFieldGroup } from './lib/formRadioFieldGroup/formRadioFieldGroup';
import type {
  FormRadioFieldGroupOption,
  FormRadioFieldGroupProps,
} from './lib/formRadioFieldGroup/formRadioFieldGroup';
import { FormSearchField } from './lib/formSearchField/formSearchField';
import { FormSelectField } from './lib/formSelectField/formSelectField';
import { FormSliderField } from './lib/formSliderField/formSliderField';
import { FormSubmitButton } from './lib/formSubmitButton/formSubmitButton';
import { FormSwitchField } from './lib/formSwitchField/formSwitchField';
import { FormTextAreaField } from './lib/formTextAreaField/formTextAreaField';
import type { FormTextFieldProps } from './lib/formTextField/formTextField';
import { FormTextField } from './lib/formTextField/formTextField';
import { FormTypeAhead } from './lib/formTypeAhead/formTypeAhead';

export type {
  FormCheckboxFieldProps,
  FormNumberFieldProps,
  FormProps,
  FormRadioFieldGroupOption,
  FormRadioFieldGroupProps,
  FormTextFieldProps,
};

export const Form = Object.assign(HookForm, {
  BaseForm: BaseForm,
  CheckboxField: FormCheckboxField,
  DateTimeField: FormDateTimeField,
  ErrorBanner: FormErrorBanner,
  NumberField: FormNumberField,
  RadioFieldGroup: FormRadioFieldGroup,
  SearchField: FormSearchField,
  SelectField: FormSelectField,
  SliderField: FormSliderField,
  SwitchField: FormSwitchField,
  SubmitButton: FormSubmitButton,
  TextAreaField: FormTextAreaField,
  TextField: FormTextField,
  TypeAhead: FormTypeAhead,
});

export { useForm } from './lib/form/formContext';
export { FormValidationError } from './lib/form/formValidationError';
export { FormFieldWrapper } from './lib/formFieldWrapper/formFieldWrapper';
// Note: Test helpers are not exported from main index to avoid pulling vitest into production/storybook bundles
// Import directly from './lib/testHelpers/withReeferHookFormWrapper.testHelper' in test files if needed
export {
  useController,
  useFieldArray,
  useFormContext,
  useWatch,
} from 'react-hook-form';
